import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "disabled", "helpfulCount", "onClickHelpful", "tooltip", "userMarkedHelpful"];
import { useCallback } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { GREAT_WHITE, KOALA, GYPSUM } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
const ActiveButton = styled(UIButton).withConfig({
  displayName: "HelpfulButton__ActiveButton",
  componentId: "msx9q5-0"
})(["background-color:", " !important;font-weight:600 !important;&:hover{background-color:", " !important;}"], GREAT_WHITE, GYPSUM);
const InactiveButton = styled(UIButton).withConfig({
  displayName: "HelpfulButton__InactiveButton",
  componentId: "msx9q5-1"
})(["background-color:", " !important;font-weight:400 !important;&:hover{background-color:", " !important;}"], KOALA, GYPSUM);
export default function HelpfulButton(_ref) {
  let {
      className,
      disabled,
      helpfulCount,
      onClickHelpful,
      tooltip,
      userMarkedHelpful
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Button = userMarkedHelpful ? ActiveButton : InactiveButton;
  const onClick = useCallback(() => {
    const clickPromise = onClickHelpful();
    if (clickPromise instanceof Promise) {
      clickPromise.catch(() => {
        FloatingAlertStore.addAlert({
          message: unescapedText('marketplace-ui-reviews.helpfulButton.error.message'),
          titleText: unescapedText('marketplace-ui-reviews.helpfulButton.error.titleText'),
          type: 'danger'
        });
      });
    }
  }, [onClickHelpful]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.actions.loginRequired"
    }),
    disabled: !disabled || !tooltip,
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
      className: className,
      size: "xs",
      disabled: disabled,
      use: "tertiary-light",
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.actions.helpful",
        options: {
          count: helpfulCount
        }
      })
    }))
  });
}